import { 
	GET_PROJECT_DRAWING_OFFICE_IFFS, 
	GET_PROJECT_DRAWING_OFFICE_IFF,
	CREATE_PROJECT_DRAWING_OFFICE_IFF,
	UPDATE_PROJECT_DRAWING_OFFICE_IFF,
	DESTROY_PROJECT_DRAWING_OFFICE_IFF,
} from "./actions"

export function ProjectDrawingOfficeIffsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_DRAWING_OFFICE_IFFS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_DRAWING_OFFICE_IFF}_FULFILLED`:
		case `${CREATE_PROJECT_DRAWING_OFFICE_IFF}_FULFILLED`:
		case `${UPDATE_PROJECT_DRAWING_OFFICE_IFF}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_DRAWING_OFFICE_IFF}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectDrawingOfficeIffsReducer } from "modules/project/drawing_office/iffs/reducer"

// project_drawing_office_iffs:ProjectDrawingOfficeIffsReducer,
